import { memo } from "react";
import { DeleteOutlined} from "@ant-design/icons";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Button, Card, Col, Input, Popconfirm, Row, Space, Tag, Tooltip, Typography } from "antd";
import DataState from "../../../components/DataState/DataState";


export function ValueAddsTabComponent({
  valueAddTotalCount,
  valueAddText,
  onValueAddTextChange,
  onAddValueAdd,
  onClearValueAdd,
  editingValueAddId,
  editingValueAddForm,
  onEditingValueAddFieldChange,
  onSaveValueAddEdit,
  onCancelValueAddEdit,
  valueAddsLoading,
  valueAddItems,
  onEditValueAdd,
  onDeleteValueAdd,
}) {
  return (
    <DataState status={valueAddsLoading ? "loading" : "ready"} skeletonRows={6}>
    <Card
      style={{ borderRadius: 14, border: "1px solid #e6ecf5", boxShadow: "0 4px 14px rgba(16,24,40,0.03)" }}
      styles={{ body: { padding: 16 } }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Typography.Title level={4} style={{ margin: 0 }}>
            Value Adds
          </Typography.Title>
          <Tag color="green">{valueAddTotalCount}</Tag>
        </div>
      </div>
      <Typography.Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
        Add one item per line. Each line will be saved as a separate value add item.
      </Typography.Text>

      <Card
        style={{ borderRadius: 10, border: "1px solid #d6e4ff", background: "#f5f8ff", marginBottom: 12 }}
        styles={{ body: { padding: 12 } }}
      >
        <Input.TextArea
          rows={4}
          value={valueAddText}
          onChange={(e) => onValueAddTextChange(e.target.value)}
          placeholder="Add value add items (one per line)..."
          style={{ marginBottom: 10 }}
        />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {valueAddText.length} characters
          </Typography.Text>
          <Space>
            <Button type="primary" onClick={onAddValueAdd}>Save</Button>
            <Button onClick={onClearValueAdd}>Clear</Button>
          </Space>
        </div>
      </Card>

      {editingValueAddId && (
        <Card
          style={{ borderRadius: 10, border: "1px solid #b7eb8f", background: "#f6ffed", marginBottom: 12 }}
          styles={{ body: { padding: 12 } }}
        >
          <Row gutter={10}>
            <Col xs={24} md={12}>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Title
              </Typography.Text>
              <Input
                value={editingValueAddForm.title}
                onChange={(e) => onEditingValueAddFieldChange("title", e.target.value)}
                placeholder="Enter title"
                style={{ marginTop: 4 }}
              />
            </Col>
            <Col xs={24}>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Description
              </Typography.Text>
              <Input.TextArea
                rows={3}
                value={editingValueAddForm.description}
                onChange={(e) => onEditingValueAddFieldChange("description", e.target.value)}
                placeholder="Enter description"
                style={{ marginTop: 4 }}
              />
            </Col>
          </Row>
          <Space style={{ marginTop: 10 }}>
            <Button type="primary" onClick={onSaveValueAddEdit}>Save</Button>
            <Button onClick={onCancelValueAddEdit}>Cancel</Button>
          </Space>
        </Card>
      )}

      <div style={{ border: "1px solid #e6ecf5", borderRadius: 12, overflow: "hidden", background: "#fff" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.5fr 3fr 1fr",
            gap: 12,
            padding: "10px 12px",
            borderBottom: "1px solid #e6ecf5",
            background: "#f8fbff",
            fontSize: 12,
            fontWeight: 600,
            color: "#64748b",
          }}
        >
          <div>TITLE</div>
          <div>DESCRIPTION</div>
          <div>ACTIONS</div>
        </div>
        {valueAddItems.map((item) => (
          <div
            key={item.id}
            style={{
              display: "grid",
              gridTemplateColumns: "1.5fr 3fr 1fr",
              gap: 12,
              padding: "12px",
              borderBottom: "1px solid #edf2f7",
              alignItems: "center",
              background: "#fff",
            }}
          >
            <div style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}>
              <span>{item.starred ? "★" : "☆"}</span>
              <span>{item.title}</span>
            </div>
            <div style={{ color: "#434343" }}>{item.description}</div>
            <div style={{ display: "flex", gap: 6 }}>
              <Tooltip title="Edit">
                <Button
                  type="text"
                  size="small"
                  icon={<EditOutlinedIcon style={{ fontSize: 15 }} />}
                  onClick={() => onEditValueAdd(item)}
                />
              </Tooltip>
              <Tooltip title="Delete">
                <Popconfirm
                  title="Delete Value Add"
                  description="Are you sure you want to delete this item?"
                  onConfirm={() => onDeleteValueAdd(item.id)}
                  okText="Delete"
                  cancelText="Cancel"
                  okButtonProps={{ danger: true }}
                >
                  <Button
                    type="text"
                    size="small"
                    icon={<DeleteOutlined />}
                    danger
                  />
                </Popconfirm>
              </Tooltip>
            </div>
          </div>
        ))}
      </div>
    </Card>
    </DataState>
  );
}

export const ValueAddsTab = memo(ValueAddsTabComponent);
